import { CLAMP } from '@/constants/values'
/**
 * transforms a numeric value to a new scale
 * @param {Number} origVal - original value
 * @param {Number} sourceScale - original max value
 * @param {Number} targetScale - new max value
 * @param {Number} sourceMin - original min value
 * @param {Number} targetMin - new min value
 */
export const scaleValue = (origVal, sourceScale, targetScale, sourceMin = 0, targetMin = 0) => {
  return ((origVal - sourceMin) / (sourceScale - sourceMin)) * (targetScale - targetMin) + targetMin;
};

export const getClampedValue = (value) => {
    if (value >= CLAMP.MAX) {
      return CLAMP.MAX;
    } else if (value <= CLAMP.MIN) {
      return CLAMP.MIN;
    }
    return value;
  };
  
export const getClampedValueLabel = (value) => {
    if (value >= CLAMP.MAX) {
        return `≥ ${CLAMP.MAX}`;
    } else if (value <= CLAMP.MIN) {
        return `≤ ${CLAMP.MIN}`;
    }
    return value;
};